import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "./BaseElement.js";
import { styleMap } from "lit/directives/style-map.js";
import { IntersectionController } from "@lit-labs/observers/intersection_controller.js";
@customElement("ac101-youtube")
export class AC101Youtube extends BaseElement {
  _observer = new IntersectionController(this, {
    target: this,

    callback: (entries) => {
      this.show = false;
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.show = true;
        }
      }
    },
  });

  get styles() {
    return css`
      :host {
        display: block;
      }
    `;
  }
  connectedCallback() {
    super.connectedCallback();
    this.style.width = `${this.width}px`;
    this.style.height = "100%";
  }

  @property({ type: String, attribute: "video-id" }) videoId: string =
    undefined;
  @property({ type: Number }) width: number;

  @state() show = false;

  render() {
    if (!this.show) {
      return html``;
    }

    return html`<iframe
      width="${this.width}"
      height="100%"
      src="https://www.youtube.com/embed/${this.videoId}"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>`;
  }
}
